import React, { Component } from 'react';
import PropTypes from 'prop-types';
import InputText from '../Common/InputText';
import Toggle from '../Common/Toggle/Toggle';
import MultiSelectBox from '../Common/MultiSelectBox/MultiSelectBox';
import UserLocationAccessForm from '../Common/UserLocationAccessForm/UserLocationAccessForm';
import RadioGroup from '../Common/RadioGroup/RadioGroup';
import { USER_LOCATION_ACCESS_OPTIONS } from '../../constants/constants';
import './InviteUserForm.scss';

export default class InviteUserForm extends Component {
    constructor(props, context) {
        super(props, context);
    }

    onUserChange = (name, value) => {
        this.props.onFormChange(name, value);
    }

    onFormChange = (e) => {
        let value = e.target.value;
        if (e.target.name === 'userName') {
            value = value.replace(/[^a-zA-Z0-9._+-@]/g, ''); // Allows letters, numbers, and specific special characters
        }

        this.onUserChange(e.target.name, value);
    }

    onSingleSelectChange = (id, name) => {
        this.onUserChange(name, id);
    }

    onEmailChange = (e) => {
        this.props.onEmailChange(e.target.value);
    };

    onMultiSelectChange = (csv, name) => {
        this.onUserChange(name, csv);
    }

    onUserLocationAccessChange = (value) => {
        this.onUserChange('selectedUserLocationAccess', value);
    }

    render() {
        return (
            <div className="invite-user-form">
                <form noValidate className={this.props.isFormValid ? "" : "was-validated"}>
                    <div className="row">
                        <div className="col-md-6">
                            <InputText name="firstName" label="First Name" placeholder="First Name" type="text" value={this.props.user.firstName} onChange={this.onFormChange} isRequired={true} errorMessage="First Name is required" />
                            <InputText name="lastName" label="Last Name" placeholder="Last Name" type="text" value={this.props.user.lastName} onChange={this.onFormChange} isRequired={true} errorMessage="Last Name is required" />
                            <InputText name="email" label="Email" placeholder="Email" type="text" value={this.props.user.email} onChange={this.onEmailChange} onBlur={this.props.onEmailBlur} isRequired={true} errorMessage="Email is required" />
                            <InputText name="userName" label="UserName" placeholder="UserName" type="text" value={this.props.user.userName} onChange={this.onFormChange} isRequired={!this.props.user.ssoUser} errorMessage="UserName is required" isDisabled={this.props.user.ssoUser}/>
                            <InputText name="jobTitle" label="Job Title" placeholder="Job Title" type="text" value={this.props.user.jobTitle} onChange={this.onFormChange} isRequired={true} errorMessage="Job Title is required" />
                            <InputText name="workPhone" label="Work Phone" placeholder="Work Phone" type="text" value={this.props.user.workPhone} onChange={this.onFormChange} />

                            <MultiSelectBox name="countryId" label="Country" idField="id" valueField="name"
                                options={this.props.countries}
                                onChange={this.onSingleSelectChange}
                                selectedValues={this.props.user.countryId.toString()}
                                isRequired={true}
                                errorMessage="Country is required"
                                isMulti={false}
                            />
                        </div>
                        <div className="col-md-6">
                            <MultiSelectBox name="roleId" label="Role" idField="id" valueField="name"
                                options={this.props.roles}
                                onChange={this.onSingleSelectChange}
                                selectedValues={this.props.user.roleId.toString()}
                                isRequired={true}
                                errorMessage="Role is required"
                                isMulti={false}
                            />

                            <MultiSelectBox name="managementCompanyId" label="Management Company" idField="id" valueField="name"
                                options={this.props.managementCompanies}
                                onChange={this.onSingleSelectChange}
                                selectedValues={this.props.user.managementCompanyId.toString()}
                                isRequired={true}
                                errorMessage="Management Company is required"
                                isMulti={false}
                            />

                            <MultiSelectBox name="communities" label="Communities" idField="id" valueField="name"
                                options={this.props.communities}
                                selectedValues={this.props.user.communities}
                                onChange={this.onMultiSelectChange}
                                isRequired={true}
                                errorMessage="At least one Community must be selected"
                                isMulti={true}
                            />

                            <MultiSelectBox name="departments" label="Favorite Departments" idField="id" valueField="name"
                                options={this.props.departments}
                                selectedValues={this.props.user.departments}
                                onChange={this.onMultiSelectChange}
                                isRequired={false}
                                errorMessage="At least one Community must be selected"
                                isMulti={true}
                            />

                            {
                                this.props.isSubscriptionProjectEnabled
                                    ?
                                    <Toggle name="excludeAsProjectCoach" text="Exclude as Project Coach" checked={this.props.user.excludeAsProjectCoach} onChange={this.onUserChange} />
                                    :
                                    null
                            }

                            <Toggle name="allowTaskListExportToExcel" text="Allow Location Task List Export to Excel" checked={this.props.user.allowTaskListExportToExcel} onChange={this.onUserChange} />
                            <Toggle name="allowLocationTaskDateChanges" text="Allow Location Task Date Changes" checked={this.props.user.allowLocationTaskDateChanges} onChange={this.onUserChange} />
                            {
                                this.props.isSubscriptionTaskFinancialsActive
                                    ?
                                    <Toggle name="allowLocationTaskBudgetEntry" text="Allow Location Task Budget Entry" checked={this.props.user.allowLocationTaskBudgetEntry} onChange={this.onUserChange} />
                                    :
                                    null
                            }

                            {
                                this.props.isSubscriptionSsoEnabled
                                    ?
                                    <Toggle name="ssoUser" text="SSO User" checked={this.props.user.ssoUser} onChange={this.onUserChange} />
                                    :
                                    null
                            }
                            {
                                this.props.isSubscriptionSsoEnabled && this.props.user.ssoUser
                                    ?
                                    <InputText 
                                        name="userName" 
                                        label="SSO Id" 
                                        placeholder="SSO Id" 
                                        type="text" 
                                        value={this.props.user.userName} 
                                        onChange={this.onFormChange} 
                                        isRequired={this.props.user.ssoUser} 
                                        errorMessage="SSO Id is required for SSO Users" />
                                    :
                                    null
                            }


                            <div>Grant User Access To All Locations</div>
                            <RadioGroup 
                                defaultValue={this.props.user.selectedUserLocationAccess}
                                value={this.props.user.selectedUserLocationAccess}
                                options={[
                                    {  value: USER_LOCATION_ACCESS_OPTIONS.NO.value, label: USER_LOCATION_ACCESS_OPTIONS.NO.label },
                                    {  value: USER_LOCATION_ACCESS_OPTIONS.YES.value, label: USER_LOCATION_ACCESS_OPTIONS.YES.label },
                                    {  value: USER_LOCATION_ACCESS_OPTIONS.RULES.value, label: USER_LOCATION_ACCESS_OPTIONS.RULES.label },
                                ]}
                                onValueChange={this.onUserLocationAccessChange} />

                            {
                                this.props.user.selectedUserLocationAccess === USER_LOCATION_ACCESS_OPTIONS.RULES.value
                                    ?
                                    <UserLocationAccessForm
                                        subscriptionId={this.props.subscriptionId}
                                        isFormValid={this.props.isUserLocationAccessFormValid}
                                        userLocationRules={this.props.user.userLocationRules}
                                        onFormChange={this.props.onUserLocationAccessFormChange}
                                        actions={this.props.locationActions}
                                    />
                                    :
                                    null
                            }
                        </div>
                    </div>
                </form>
            </div>
        );
    }
}

InviteUserForm.propTypes = {
    subscriptionId: PropTypes.string.isRequired,
    isFormValid: PropTypes.bool.isRequired,
    isSubscriptionProjectEnabled: PropTypes.bool.isRequired,
    isSubscriptionSsoEnabled: PropTypes.bool.isRequired,
    isSubscriptionTaskFinancialsActive: PropTypes.bool.isRequired,
    user: PropTypes.object.isRequired,
    countries: PropTypes.array.isRequired,
    roles: PropTypes.array.isRequired,
    managementCompanies: PropTypes.array.isRequired,
    communities: PropTypes.array.isRequired,
    departments: PropTypes.array.isRequired,
    onFormChange: PropTypes.func.isRequired,
    onEmailChange: PropTypes.func.isRequired,
    onEmailBlur: PropTypes.func.isRequired,
    isUserLocationAccessFormValid: PropTypes.bool.isRequired,
    onUserLocationAccessFormChange: PropTypes.func.isRequired,
    locationActions: PropTypes.object.isRequired
}
